import { render, staticRenderFns } from "./DataTablePlayground.vue?vue&type=template&id=1d96af60&"
import script from "./DataTablePlayground.vue?vue&type=script&lang=js&"
export * from "./DataTablePlayground.vue?vue&type=script&lang=js&"
import style0 from "./DataTablePlayground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports